import { service } from '../services/request';

export function authMoshUser(data: any) {
    return service({
        url: '/api/v1/authenticate/auth',
        method: 'post',
        data,
    });
}
